export const PVI_CHECKLIST = [
  {
    key: "equipmentCompliant",
    label:
      "Equipment compliant with standards, correctly selected and not damaged:",
  },
  {
    key: "accessible",
    label: "Equipment accessible for operation, inspection and maintenance:",
  },
  {
    key: "correctlyConnected",
    label: "Equipment and accessories correctly connected:",
  },
  {
    key: "protectiveMeasures",
    label: "Particular protective measures for special location:",
  },
  {
    key: "appropriateExternalInfluences",
    label:
      "Equipment and protective measures appropriate to external influences:",
  },
  {
    key: "mutualInfluence",
    label: "System installed to prevent mutual detrimental influence:",
  },
  {
    key: "conductorsConnected",
    label: "Conductors connected and identified:",
  },
  {
    key: "currentCapacity",
    label:
      "Conductors selected for current carrying capacity and voltage drop:",
  },
  {
    key: "safeRouting",
    label:
      "Conductors routed in a safe zone or protected against mechanical damage:",
  },
  {
    key: "fireBarriers",
    label:
      "Presence of fire barriers, seals and protection against thermal effects:",
  },
  {
    key: "ventilation",
    label:
      "Ventilation provided behind array to prevent overheating / fire risk:",
  },
  {
    key: "corrosionProof",
    label: "Array frame and material corrosion proof:",
  },
  {
    key: "stableFrame",
    label:
      "Array frame correctly fixed and stable; roof fittings weatherproof:",
  },
  {
    key: "weatherproofEntry",
    label: "Cable entry weatherproof:",
  },
  {
    key: "livePartsProtected",
    label:
      "Live parts insulated/protected or placed out of reach / Class II:",
  },
  {
    key: "equipotentialBonding",
    label:
      "Array frame equipotential bonding present (Only relevant if required - see table 2):",
  },
  {
    key: "surgeProtection",
    label: "Surge protection devices present (only relevant if required):",
  },
  {
    key: "rcdProvided",
    label: "RCD provided (only relevant if required):",
  },
  {
    key: "lpsIntegration",
    label: "Frame correctly integrated with existing LPS installation:",
  },
  {
    key: "acDcSeparation",
    label: "Physical separation of AC and DC cables:",
  },
  {
    key: "dcSwitch",
    label: "DC switch disconnect or fitted (to IEC60364-712.536.2.2):",
  },
  {
    key: "dcInsulation",
    label:
      "DC cables – protective and reinforced insulation (only relevant if required):",
  },
  {
    key: "dcRated",
    label:
      "All DC components rated for operation at max DC system voltage (Voc stc x 1.25):",
  },
  {
    key: "pvStringsFused",
    label:
      "PV strings fused or blocking diodes fitted (only relevant if required):",
  },
  {
    key: "acIsolatorLockable",
    label: "AC Isolator lockable in off position only:",
  },
  {
    key: "meterReadable",
    label: "Generation Meter readable without torch or ladder and sealed:",
  },
  {
    key: "inverterSettings",
    label: "Inverter protection settings to local regulations:",
  },
  {
    key: "labelingCircuits",
    label:
      "General labelling of circuits, protective devices switches and terminals (to IEC60364-6-61):",
  },
  {
    key: "schematicDisplayed",
    label: "PV system schematic displayed on site:",
  },
  {
    key: "settingsDisplayed",
    label: "Protection settings and installer details displayed on site:",
  },
  {
    key: "shutdownProcedure",
    label: "Emergency shutdown procedure displayed on site:",
  },
  {
    key: "acIsolatorLabeled",
    label: "AC Isolator clearly labeled:",
  },
  {
    key: "dcBoxesLabeled",
    label: "DC isolator / junction boxes suitably labeled:",
  },
  {
    key: "labelsDurable",
    label: "Signs and labels suitably affixed and durable:",
  },
  {
    key: "dnoInfo",
    label: "DNO information collected:",
  },
  {
    key: "arrayReport",
    label: "PV Array Report completed:",
  },
  {
    key: "buildingNotification",
    label:
      "Notification to Building Control/ electrical certificates completed:",
  },
];
